var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DForm',_vm._g(_vm._b({},'DForm',_vm.$attrs,false),_vm.$listeners),[_c('DField',{key:"name",attrs:{"field":"text","field-style":"1","label":"nombre","dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }